import React from "react";

import { Text } from "@performyard/py-components";

import Breadcrumbs from "../../../../components/Breadcrumbs";

import { config } from "../config";

type MeetingsTableBreadcrumbsProps = {
	workspaceName: string;
	workspaceId: string;
	previousSearchParams?: string;
};

const MeetingsTableBreadcrumbs = ({
	workspaceName,
	workspaceId,
	previousSearchParams = "",
}: MeetingsTableBreadcrumbsProps): React.ReactElement => {
	return (
		<Breadcrumbs
			pages={[
				{
					pageID: "meetingWorkspaces",
					label: "Meeting Workspaces",
					url: previousSearchParams ? `/meeting-workspaces${previousSearchParams}` : "/meeting-workspaces",
				},
				{
					pageID: "workspaceDetails",
					label: (
						<div className="py-text-truncate" style={{ maxWidth: config.layout.breadcrumbMaxWidth }}>
							<Text size="paragraph-2" weight="regular" overrideElement="span" wrap={false}>
								{workspaceName}
							</Text>
						</div>
					),
					url: `/meeting-workspaces/${workspaceId}`,
				},
			]}
		/>
	);
};

export default MeetingsTableBreadcrumbs;
